<template>
  <div v-if="this.$props.showModal">
    <div id="myModal" :class="[$style.modal]" @blur="hideModal()">
      <div :class="[$style.modalContent]">
        <div :class="[$style.divClose]">
          <span :class="[$style.close]" @click="hideModal()">&times;</span>
        </div>
        <div :class="[$style.headerModal]">
          <div :class="$style.text">
            <PdsTexting>¿Qué cédula de identidad tienes?</PdsTexting>
          </div>
        </div>
        <div :class="[$style.modalBody]">
          <div :class="[$style.textLeft]">
            <PdsTexting format="body4" bold>Nueva</PdsTexting>
            <div :class="$style.imgCenter">
              <img src="@/assets/images/cedula1.png" />
            </div>
            <PdsTexting :class="$style.descriptionText" format="body4">
              Aparece al frente como:
              <br><b>N° de Documento</b>
            </PdsTexting>
          </div>
          <div :class="$style.textLeft">
            <PdsTexting format="body4" bold>Antigua</PdsTexting>
            <div :class="$style.imgCenter">
              <img src="@/assets/images/cedula2.png" />
            </div>
            <PdsTexting :class="$style.descriptionText" format="body4">
              Aparece atras como:
              <br><b>N° de Documento</b>
            </PdsTexting>
          </div>
        </div>
        <div :class="$style.buttonContinue">
          <PdsButton
          :class="$style.buttonContinue"
          label="Cerrar"
          role="tertiary"
          @click="hideModal"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PdsButton from '@vue-pds/button';
import PdsTexting from '@vue-pds/texting';

export default {
  name: 'ModalCI',
  data() {
    return {
    };
  },
  components: {
    PdsButton,
    PdsTexting,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  methods: {
    hideModal() {
      this.$emit('disable', false);
    },
  },
};
</script>

<style lang="scss" scoped module>

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding-top: 100px;
  overflow: auto;
  letter-spacing: normal;
  background-color: rgba(0, 0, 0, 0.4);
}

.colorText {
  margin-top: 30px;
  font-size: 24px;
  font-style: normal;
  color: #c00000;
  text-align: center;
}

.text {
  font-size: 24px;
  font-style: normal;
  text-align: center;
}

.textLeft {
  margin-bottom: 48px;
  text-align: left;
}

.descriptionText {
  line-height: 16px;
}

.imgCenter {
  padding: 8px 0;
  margin: 0 auto;
  text-align: center;
}

.modalContent {
  box-sizing: border-box;
  max-width: 600px;
  padding: 20px 0 40px;
  margin: auto;
  color: #000000;
  background-color: #fefefe;
  border: 1px solid #c5c6c5;
  border-radius: 8px;
}

.divClose {
  padding: 0 30px;
  text-align: right;

  .close {
    font-size: 28px;
    color: #035fa4;
  }

  .close:hover,
  .close:focus {
    color: #035fa4;
    text-decoration: none;
    cursor: pointer;
  }
}

.headerModal {
  padding: 0 30px 24px;
  color: #333333;
  text-align: center;
}

.modalBody {
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
  text-align: center;
}

.overAuto {
  overflow: auto;
}

.overHidden {
  overflow: hidden;
}

.shadowHeader {
  box-shadow: rgba(0, 0, 0, 0.35) 0 11px 10px;
}

.shadowFooter {
  box-shadow: rgba(0, 0, 0, 0.35) 0 -11px 10px;
}

.footerModal {
  z-index: 2;
  background-color: #ffffff;

  .divLink {
    margin: 0 auto;

    .link {
      display: flex;
      width: 220px;
      margin: 0 auto 35px;
      text-align: center;

      .icon {
        padding-right: 7px;
      }
    }
  }
}

.buttonContinue {
  max-width: 326px;
  height: 42px;
  padding: 0 40px;
  margin: 0 auto;
  text-align: center;

  button {
    display: block;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .modalContent {
    max-width: 374px;
  }

  .modalBody {
    display: inherit;
  }
}
</style>
